enum NamingConvention {
    Default = "default",
    Original = "original",
    SnakeCase = "snakeCase",
    CamelCase = "camelCase",
    KebabCase = "kebabCase",
    UpperCamelCase = "upperCamelCase"
}

export default NamingConvention;
